<form [formGroup]="dialCodeForm" class="tablelist-form" autocomplete="off">
  <label class="form-label"
    [class.required]="isRequired('mobilenumber')"
  >
    Mobile
  </label>
  <div class="input-group dropdown"
    data-input-flag
    [ngClass]="{
      'is-invalid': formSubmitted && (!selectedCountry || formOfDialCode['mobilenumber'].invalid || validationMessage)
    }"
  >

    <button
      #dropdownButton
      aria-expanded="false"
      class="btn btn-light border"
      data-bs-toggle="dropdown"
      [disabled]="disabled"
      id="countryDropdownButton"
      type="button"
    >
      @if (selectedCountry) {
        <img [src]="selectedCountry.countryFlag" alt="flag img" height="20" class="rounded" />
        <span class="ms-2 country-codeno">{{ selectedCountry.diallingCode }}</span>
      } @else {
        <span class="country-codeno text-muted">?</span>
      }
    </button>
    
    <input
      class="form-control rounded-end flag-input"
      formControlName="mobilenumber"
      oninput="this.value = this.value.replace(/[^0-9]/g, '');"
      placeholder="Enter number"
      type="text"
      (input)="onMobileNumberChange()"
    />
    
    <div class="dropdown-menu w-100 p-0">
      <div class="p-2 px-3 pt-1 searchlist-input">
        <input
          class="form-control form-control-sm border search-countryList"
          formControlName="search"
          placeholder="Search country name or country code..."
          type="text"
          (input)="onSearchInputChange($event)"
        />
      </div>

      <ul class="list-unstyled dropdown-menu-list mb-0">
        <li *ngFor="let data of countriesDataFiltered">
          <a
            class="dropdown-item d-flex align-items-center"
            (click)="countriesSelectOnChange(data)"
          >
            <button
              class="btn btn-sm p-0 me-2 dial-code-pin"
              [class.is-pinned]="isPinned(data)"
              [title]="isPinned(data) ? 'Unpin' : 'Pin to top'"
              type="button"
              (click)="togglePinned(data, $event)"
            >
              <i [class]="isPinned(data) ? 'ri-pushpin-2-fill' : 'ri-pushpin-2-line'"></i>
            </button>
            <img [src]="data.countryFlag" height="20" class="me-2 rounded" />
            {{ data.countryName }}
            <span class="ms-auto text-muted">{{ data.diallingCode }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  @if (!selectedCountry) {
    <div class="invalid-feedback">Select a country code (on left)</div>
  } @else if (validationMessage) {
    <div class="invalid-feedback">{{ validationMessage }}</div>
  } @else {
    <div class="invalid-feedback">A value is required for mobile</div>
  }
</form>
